/**
 * Breadcrumbs Component
 * 
 * Navigation breadcrumbs for PDP
 */

'use client';

import styled from '@emotion/styled';
import { Text } from '@template-project/afrodita-components';

const BreadcrumbsContainer = styled.nav`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.space.xs};
  padding: ${({ theme }) => `${theme.space.md} 0`};
  font-size: ${({ theme }) => theme.fontSizes[1]}px;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

const BreadcrumbLink = styled.a`
  color: ${({ theme }) => theme.colors.text.secondary};
  text-decoration: none;
  transition: color 0.2s;
  
  &:hover {
    color: ${({ theme }) => theme.colors.text.primary};
    text-decoration: underline;
  }
`;

const Separator = styled.span`
  color: ${({ theme }) => theme.colors.text.secondary};
  user-select: none;
`;

const CurrentPage = styled.span`
  color: ${({ theme }) => theme.colors.text.primary};
`;

export interface BreadcrumbItem {
  label: string;
  href?: string;
}

export interface BreadcrumbsProps {
  items: BreadcrumbItem[];
}

export function Breadcrumbs({ items }: BreadcrumbsProps) {
  return (
    <BreadcrumbsContainer aria-label="Breadcrumb">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        
        return (
          <span key={index} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            {item.href && !isLast ? (
              <BreadcrumbLink href={item.href}>
                {item.label}
              </BreadcrumbLink>
            ) : (
              <CurrentPage>{item.label}</CurrentPage>
            )}
            {!isLast && <Separator>→</Separator>}
          </span>
        );
      })}
    </BreadcrumbsContainer>
  );
}

